<script setup lang="ts">
import { provide } from 'vue';
    import FilterBySeries from './components/FilterBySeries.vue';
    import AppliedFilters from './components/AppliedFilters.vue';
    import FacetPanel from './components/FacetPanel.vue';
    import InformationResults from './components/InformationResults.vue';
    import LoadingOverlay from './components/LoadingOverlay.vue';
    import NoResults from './components/NoResults.vue';
    import Pagination from './components/Pagination.vue';
    import SearchControls from './components/SearchControls.vue';
    import SearchResults from './components/SearchResults.vue';
    import type { SearchAppConfig } from './models/SearchModels';
    import { searchKey } from './composables/searchContext';
    import { useSearch } from './composables/useSearch';

    const props = defineProps<{ config: SearchAppConfig }>();
    const search = useSearch(props.config);
    provide(searchKey, search);
</script>

<template>
    <div id="SearchDiv" class="search-vue-app" aria-live="polite">
        <!--<section v-if="search.cmsContent.value.HeaderContent" id="SearchCMSHeaderDiv" class="search-cms-header" :style="{ background: search.cmsContent.value.Background }">
            <div v-html="search.cmsContent.value.HeaderContent"></div>
        </section>-->
        <p v-if="search.searchError.value" id="Search_Error" role="alert">
            <span class="SearchCMSHeaderDiverr">{{ search.searchError.value }} If you have any queries please contact <a href="/contact-us?type=customer service">customer service.</a></span>
        </p>
        <div v-else id="SearchContentDiv" class="row angcontent">

            <div class="row search-layout">
                <aside id="left-menu" class="left-menu" aria-label="Search filters">
                    <SearchControls v-if="search.isLoading.value || search.totalResults.value > 0" />
                    <FilterBySeries v-if="search.isLoading.value || search.totalResults.value > 0" />
                    <AppliedFilters v-if="search.state.division !== 'all'" class="desktop-applied-filters" />
                    <FacetPanel />
                </aside>
                <main id="right-menu" class="right-menu">
                    <div v-if="search.cmsContent.value.ConfigContent" id="SearchCMSContentDiv" class="searchcontainer" v-html="search.cmsContent.value.ConfigContent"></div>
                    <SearchResults v-if="search.state.resultType === 'P' && search.productCount.value > 0" />
                    <InformationResults v-else-if="search.state.resultType === 'I' && search.informationCount.value > 0" />
                    <NoResults v-else-if="!search.isLoading.value" />
                </main>
            </div>
            <Pagination v-if="search.totalResults.value > 0" />
            <div id="pagerinfobox" v-if="search.totalResults.value > 0">
                <span><strong>{{ search.startResult.value }} - {{ search.endResult.value }}</strong></span>
                <span> out of {{ search.totalResults.value }} {{ search.state.resultType === 'P' ? 'products' : 'pages' }}</span>
            </div>
        </div>
        <LoadingOverlay />
    </div>
</template>
